import React from 'react';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

const DraftLabel = () => {
  return (
    <Tag
      className='bg-secondary text-text-heading font-semibold'
      icon={<ExclamationCircleOutlined className='text-text-heading' />}
    >
      Rascunho
    </Tag>
  );
};

export default DraftLabel;
